/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React, { useCallback, useState } from 'react'
import { ReactZoomPanPinchRef, TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import { ReactComponent as FocusIcon } from '@material-design-icons/svg/round/filter_center_focus.svg'

import IconButton from 'components/common/IconButton'

import c from './ImagePreviewSpace.module.scss'

interface ImagePreviewSpaceProps {
  imageUrl: string
  onLoad?: () => void
  onLoadError?: () => void
}

function ImagePreviewSpace({
  imageUrl,
  onLoad,
  onLoadError,
}: ImagePreviewSpaceProps) {
  const [isZoomed, setIsZoomed] = useState(false)

  // ✅ Правильная типизация
  const handleZoomChange = useCallback((ref: ReactZoomPanPinchRef) => {
    const { scale } = ref.state
    setIsZoomed(scale > 1)
  }, [])

  return (
    <div className={c.wrapper}>
      <TransformWrapper
        initialScale={1}
        minScale={1}
        maxScale={5}
        wheel={{ step: 0.2 }}
        pinch={{ step: 5 }}
        doubleClick={{ disabled: false, mode: 'toggle' }}
        onTransformed={handleZoomChange}
        centerOnInit
      >
        {({ resetTransform }: { resetTransform: () => void }) => (
          <>
            <TransformComponent
              wrapperClass={c.transformWrapper}
              contentClass={c.transformContent}
            >
              <img
                className={c.image}
                src={imageUrl}
                alt=""
                onLoad={onLoad}
                onError={onLoadError}
              />
            </TransformComponent>

            <IconButton
              disabled={!isZoomed}
              className={c.resetButton}
              onClick={() => {
                resetTransform()
                setIsZoomed(false)
              }}
            >
              <FocusIcon style={{ fill: 'currentColor' }} />
            </IconButton>
          </>
        )}
      </TransformWrapper>
    </div>
  )
}

export default ImagePreviewSpace